import React from "react";
import styles from "./ota-drawer-form.module.scss";
import { Textarea } from "@src/components/atoms/textarea/textarea";
import { OtaDrawerDataInterface } from "@src/types/ota-update";
import { Input2026 } from "@src/components/atoms/input-2026/input-2026";
import OtaDrawerMarkDownSupport from "@src/components/atoms/ota-drawer-markdown-support/ota-drawer-markdown-support";
import { DropAreaAddFirmware } from "@src/components/atoms/drop-area-add-firmware/drop-area-add-firmware";
import { useOTADrawerForm } from "@src/components/molecules/ota-drawer-form/use-ota-drawer-form";
const cssClassName = "ota-drawer-form";

interface OtaDrawerFormProps {
  values: OtaDrawerDataInterface;
  setValues: React.Dispatch<React.SetStateAction<OtaDrawerDataInterface>>;
}

export const OtaDrawerForm = ({ values, setValues }: OtaDrawerFormProps) => {
  const { uploadFileText, firmwareFields, releaseNotesFields } =
    useOTADrawerForm({ values, setValues });

  return (
    <div className={styles[`${cssClassName}`]}>
      <DropAreaAddFirmware
        label={uploadFileText}
        values={values}
        keyProp={"file"}
        setValues={setValues}
      />
      {firmwareFields.map((field) => {
        return <Input2026 key={field.id} {...field} />;
      })}
      <OtaDrawerMarkDownSupport />
      {releaseNotesFields.map((field) => {
        return <Textarea key={field.id} {...field} />;
      })}
    </div>
  );
};
